class HowItWorks {
  constructor(dom) {
    this.NAME = 'HowItWorks';
    this.dom = dom;
    this.poster = dom.querySelector('[data-howitworks-poster]');
    this.play = dom.querySelector('[data-howitworks-play]');
    this.embed = dom.querySelector('[data-howitworks-embed]');
  }

  init() {
    if (!this.poster || !this.play || !this.embed) return;

    this.play.addEventListener('click', () => {
      this.poster.hidden = true;
      this.embed.hidden = false;
    });
  }
}

export default HowItWorks;
